import { render, staticRenderFns } from "./PriceVariant.vue?vue&type=template&id=0fdea7ac&"
import script from "./PriceVariant.vue?vue&type=script&lang=js&"
export * from "./PriceVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports